import { NavLink, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { path: '/admin/funds',               label: 'Funds',               icon: '💼' },
  { path: '/admin/streams',             label: 'Fund Streams',         icon: '🌊' },
  { path: '/admin/countries',           label: 'Countries & Currencies', icon: '🌍' },
  { path: '/admin/fx-rates',            label: 'Year-end FX Rates',    icon: '💱' },
  { path: '/admin/users',              label: 'Users',                icon: '👥' },
  { path: '/admin/rubrics',            label: 'Rubrics',              icon: '📊' },
  { path: '/admin/ddq',                label: 'DDQ Templates',        icon: '📋' },
  { path: '/admin/term-sheet-templates', label: 'Term Sheet Templates', icon: '📄' },
  { path: '/admin/approval-sequences', label: 'Approval Sequences',   icon: '✅' },
  { path: '/admin/sla',                label: 'SLA Configuration',    icon: '⏱️' },
  { path: '/admin/instruments',        label: 'Instrument Types',     icon: '🔧' },
  { path: '/admin/ic-members',         label: 'IC Members',           icon: '🏛️' },
];

export default function Sidebar() {
  const navigate = useNavigate();

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <h2>Mirepa Investment Advisors</h2>
        <p>Admin Configuration Portal</p>
      </div>

      {/* Back to portal — always visible to dual-role users */}
      <div
        onClick={() => navigate('/dashboard')}
        style={{
          cursor: 'pointer',
          padding: '10px 20px',
          color: 'var(--color-accent)',
          fontSize: 13,
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          marginBottom: 8,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          opacity: 0.85,
        }}
        onMouseEnter={e => { e.currentTarget.style.opacity = '1'; }}
        onMouseLeave={e => { e.currentTarget.style.opacity = '0.85'; }}
      >
        ← Back to Portal
      </div>

      <div className="sidebar-section-label">Configuration</div>
      <nav className="sidebar-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `sidebar-nav-link${isActive ? ' active' : ''}`
            }
          >
            <span className="sidebar-nav-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
